module.exports = __webpack_public_path__ + "img/green_048.b6b96dd4.png";